"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intents = require("@ux/intents");
var _intents2 = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _default = exports.default = function () {
  _intents2.default.create('@ux/toggle', {
    expressions: [_intents.enums.interactions.CHOSEN],
    features: {
      [_intents.enums.features.BODY]: {
        styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.BORDER_COLOR]
      },
      [_intents.enums.features.KNOB]: {
        styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.BORDER_COLOR]
      },
      [_intents.enums.features.LABEL]: {
        styleProperties: [_intents.enums.properties.FONT_FAMILY, _intents.enums.properties.FONT_SIZE, _intents.enums.properties.FONT_WEIGHT, _intents.enums.properties.LINE_HEIGHT, _intents.enums.properties.FOREGROUND_COLOR]
      }
    }
  });

  /**
   * uxToggle Fallback values
   */
  _intents2.default.uxToggle.body.borderColor = _intents2.default.ux.control.borderColor;
  _intents2.default.uxToggle.body.backgroundColor = _intents2.default.ux.control.backgroundColor;
  _intents2.default.uxToggle.knob.borderColor = _intents2.default.ux.control.backgroundColor;
  _intents2.default.uxToggle.knob.backgroundColor = _intents2.default.ux.control.borderColor;
  _intents2.default.uxToggleChosen.body.borderColor = _intents2.default.ux.feedback.feedbackColor;
  _intents2.default.uxToggleChosen.body.backgroundColor = _intents2.default.ux.feedback.feedbackColor;
  _intents2.default.uxToggleChosen.knob.borderColor = _intents2.default.ux.feedback.feedbackColor;
  _intents2.default.uxToggleChosen.knob.backgroundColor = _intents2.default.ux.feedback.feedbackColor;
  return _intents2.default;
}();